import { Image, View } from "react-native";
import { appConfigStore } from "../../../app/stores/AppConfig";
import { Typography, useTheme } from "@mui/material";
import { useStoreConfig } from "../../../contexts/StoreConfigContext";

export const NavBarLogo = () => {
    const darkMode = appConfigStore((state) => state.darkMode);
    const theme = useTheme();
    const { config } = useStoreConfig();

    // Check if logo is URL, data URL, or local asset
    const isUrl = config.appLogo.startsWith('http://') || config.appLogo.startsWith('https://') || config.appLogo.startsWith('data:');
    const logoImage = isUrl
        ? { uri: config.appLogo }
        : darkMode
            ? require("../../../assets/icon-white-bg.svg")
            : require("../../../assets/icon-black-bg.svg");

    // Use Google Font if set, otherwise use local font
    const logoFontFamily = config.logoFont 
        ? `'${config.logoFont}', sans-serif` 
        : 'logoFont';

    return (
        <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Image
                style={{
                    width: 40,
                    height: 40,
                    resizeMode: "contain",
                }}
                source={logoImage}
            />
            <Typography
                variant="h6"
                sx={{
                    color: theme.palette.text.primary,
                    fontWeight: "bold",
                    marginLeft: "12px",
                    alignSelf: "center",
                    fontSize: "20px",
                    letterSpacing: 0.5,
                    fontFamily: logoFontFamily,
                }}
            >
                {config.appHeaderName}
            </Typography>
        </View>
    );
}; 